export function LoadingState({ label = "Loading..." }: { label?: string }) {
  return (
    <div className="centered-state" role="status" aria-live="polite">
      <div className="loader" aria-hidden />
      <p>{label}</p>
    </div>
  );
}
